import {
  transactionHistoryStatusList,
  transactionStatusMap
} from "../../services/constants";
import classes from "./transaction-history-container.module.css";

const TransactionTableStatus = props => {
  const { status } = props;
  if (transactionHistoryStatusList.includes(status)) {
    const { color, background, dotColor, label } = transactionStatusMap[status];
    return (
      <div className={classes.tableStatus} style={{ color, background }}>
        <span className={classes.statusDot} style={{ color: dotColor }}>
          &#9679;
        </span>
        {label}
      </div>
    );
  } else return null;
};

export default TransactionTableStatus;
